import React from 'react';
import { ConfigProvider } from 'antd';
import { shallowEqual, useSelector } from 'react-redux';
import useBodyClass from './helpers/useBodyClass';
import AppLocale from './configs/app-locale';
import i18n from './configs/i18next';
import useDocumentTitle from './helpers/projectTitle';
import { PROJECT_NAME } from './configs/app-global';
import enLang from 'antd/es/locale/en_US';

export default function Providers({ children }) {
  const { theme } = useSelector((state) => state.theme, shallowEqual);
  useBodyClass(`dir-${theme.direction}`);
  const { settings } = useSelector((state) => state.globalSettings);
  useDocumentTitle(settings.title || PROJECT_NAME);

  // Fallback to English if the current language has no Antd locale mapping
  const antdLocale = AppLocale[i18n.language] || enLang;

  return (
    <ConfigProvider direction={theme.direction} locale={antdLocale}>
      {children}
    </ConfigProvider>
  );
}
